<template>
  <v-row dense>
    <v-col
      v-for="item in totalesIva"
      :key="item.key"
      cols="12"
      sm="6"
    >
      <v-text-field
        outlined
        dense
        v-validate="'decimal:2|max:12|min:0'"
        :label="`IVA ${item.key}%`"
        :error-messages="errors.collect(`iva-${item.key}`)"
        :data-vv-name="`iva-${item.key}`"
        v-model.number="item.value"
        type="number"
        suffix="$"
        maxlength="12"
        @input="emitChange"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'TotalesIvaFields',
  props: {
    totalesIva: {
      type: Array,
      required: true
    }
  },
  inject: ['$validator'], // vee-validate 2.x
  methods: {
    emitChange() {
      this.$emit('update:totalesIva', this.totalesIva)
    }
  }
}
</script>
